import React from 'react';
import PropTypes from 'prop-types';

const ExpandIcon = ({ className, expandable }) =>
  expandable ? (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
      <path className="cta-icon" d="M12 5.4H6.6V0H5.4v5.4H0v1.2h5.4V12h1.2V6.6H12z" />
    </svg>
  ) : null;

ExpandIcon.propTypes = {
  className: PropTypes.string,
  expandable: PropTypes.bool,
};

ExpandIcon.defaultProps = {
  className: '',
  expandable: false,
};

export default ExpandIcon;
